/**
 * Deterministic id helpers. We avoid pulling in a uuid dependency at the engine
 * layer so the engine stays dependency-free and tree-shakeable. Callers that
 * need cryptographic ids (the API) provide their own.
 */
let counter = 0;
/** Monotonic, process-local id useful for engine-generated segments. */
export function localId(prefix = 'id') {
    counter += 1;
    return `${prefix}_${Date.now().toString(36)}_${counter.toString(36)}`;
}
/** Reset the counter - used by deterministic tests. */
export function __resetIdCounter() {
    counter = 0;
}
//# sourceMappingURL=ids.js.map